<template>
    <div>
        <ListView @click="clickService" title="Services" :items="services"></ListView>
    </div>
</template>
<script>
import {firebase} from '../../main';
import ListView from '@/components/design/ListView';

export default {
    data() {
        return {
            isLoading: true,
            services: []
        }
    },
    methods: {
        clickService(item) {
            if(item.hasOwnProperty("url")) {
                window.open(item.url, "_blank");
            }
        }
    },
    mounted() {
        firebase.firestore().collection("services").onSnapshot(docs => {
            this.services = [];
            docs.forEach(doc => {
                this.$set(this.services, this.services.length, doc.data());
            });
            this.isLoading = false;
        });
    },
    components: {
        ListView
    }
}
</script>